import React from 'react';
import { useDataHelper } from 'utils/dataHelper';
import { theme } from 'theme';
import { SdmTypography, SdmSpacer, SdmRichText } from 'components';
import { breakoutRoomModel } from 'entities/breakoutRoomModel';
import Grid from '@material-ui/core/Grid';

export const Body = ({ fetchedBr, isXsDown }) => {
  const { getSummaryMessage, parseRichText } = useDataHelper();

  return (
    <>
      <Grid item sm={2}></Grid>
      <Grid item sm={8} xs={12}>
        <SdmTypography
          textAlign={isXsDown ? 'center' : 'left'}
          variant={'h2'}
          margin={0}
          style={{
            color: theme.colors.primary.black,
            margin: '8px 0',
          }}
        >
          {getSummaryMessage({
            isChatType: fetchedBr.type === breakoutRoomModel.enums.types.CHAT,
            info: {
              brandName: fetchedBr?.brand?.name || '',
              date: fetchedBr.date,
              start: fetchedBr.start,
              end: fetchedBr.end,
            },
          })}
        </SdmTypography>
        <SdmSpacer height={15} />
        <SdmSpacer
          height={2}
          width={193}
          style={{
            backgroundColor: theme.colors.primary.red,
            margin: isXsDown ? '0 auto' : '0',
          }}
        />
        <SdmSpacer height={40} />
        <SdmTypography
          variant={'h4Regular'}
          margin={0}
          style={{
            color: theme.colors.primary.black,
            margin: '8px 0',
          }}
          textAlign={isXsDown ? 'center' : 'left'}
        >
          <SdmRichText
            value={parseRichText(fetchedBr.description)}
            variant={'white'}
            formControlStyle={{
              margin: 0,
            }}
            editorStyleOverride={{
              minHeight: 96,
              maxHeight: 300,
              padding: 0,
              margin: 0,
            }}
            readOnly
          />
        </SdmTypography>
      </Grid>
      <SdmSpacer height={40} />
      <Grid item sm={2}></Grid>
    </>
  );
};
